import { Injectable } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { MAP_TYPES } from '@finder/shared/components/map/defaults/map.defaults.constants';
import { Leaflet } from '@finder/shared/components/map/map/leaflet';
import { MapCardService } from '@finder/shared/services/map-card/map-card.service';
import { FinderAnalyticsService } from '@finder/shared/services/finder-analytics/finder-analytics.service';
import { ConfigService } from '@finder/core/config.service';
import { DebugLogService } from '@finder/shared/services/debug-log/debug-log.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { OperatingStatusService } from '@finder/shared/components/operating-status/operating-status.service';

@Injectable()
export class MapFactoryService {

    private CLASS_NAME = '[FINDER-MAP-FACTORY] -';

    constructor(
        private loggerService: LoggerService,
        private mapCardService: MapCardService,
        private operatingStatusService: OperatingStatusService,
        private finderAnalyticsService: FinderAnalyticsService,
        private configService: ConfigService,
        private debugLogService: DebugLogService,
        private windowRef: WindowRef,
    ) { }

    /**
     * @name        createMap
     * @description Create a map
     * @param       location DOM location the map will be placed
     * @param       config Values used to create the map
     * @param       type
     * @returns     Leaflet
     */
    public createMap(location: string, config: any, type: string = MAP_TYPES.LEAFLET) {
        let map;

        switch (type) {
            case MAP_TYPES.LEAFLET:
                map = new Leaflet(
                    location,
                    config,
                    this.mapCardService,
                    this.operatingStatusService,
                    this.finderAnalyticsService,
                    this.configService,
                    this.debugLogService,
                    this.windowRef
                );
                break;
            default:
                this.loggerService.warn(`${this.CLASS_NAME} map type ${type} is not available`);
                break;
        }

        return map;
    }

}
